import React from "react";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import reactImage from "../assets/react.png";
import typescript from "../assets/typescript.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import redux from "../assets/redux.png";
import jest from "../assets/jest.png";
import postman from "../assets/postman.png";
import node from "../assets/node.png";
import mongodb from "../assets/mongodb.png";
import express from "../assets/express.png";
import npm from "../assets/npm.png";
import chakra from "../assets/chakra.png";
import GitHubCalendar from 'react-github-calendar';
import AOS from "aos";
import "aos/dist/aos.css"
import { useEffect } from "react";


const Skills = () => {
  const percentage = 75;

  const techs = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: reactImage,
      title: "React",
      style: "shadow-cyan-500",
    },
    {
      id: 5,
      src: redux,
      title: "Redux",
      style: "shadow-purple-600",
    },
    {
      id: 6,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 7,
      src: chakra,
      title: "Chakra UI",
      style: "shadow-cyan-400",
    },

    {
      id: 8,
      src: typescript,
      title: "Typescript",
      style: "shadow-blue-400",
    },

    {
      id: 9,
      src: jest,
      title: "Jest",
      style: "shadow-orange-400",
    }
  ];

  const backend = [
    {
      id: 10,
      src: node,
      title: "NodeJS",
      style: "shadow-green-400",
    },
    {
      id: 11,
      src: express,
      title: "Express",
      style: "shadow-gray-400",
    },
    {
      id: 12,
      src: mongodb,
      title: "Mongodb",
      style: "shadow-green-400",
    },
    
  ]
  const other = [
    {
      id: 13,
      src: github,
      title: "GitHub",
      style: "shadow-gray-400",
    },
    {
      id: 14,
      src: postman,
      title: "PostMan",
      style: "shadow-orange-400",
    },
    {
      id: 15,
      src: npm,
      title: "NPM",
      style: "shadow-red-400",
    },
  ]
  useEffect(()=>{
    AOS.init({delay:200});
},[])

  return (
    <div
      name="skills"
      className="min-w-full bg-gradient-to-b to-gray-800 from-black w-full pt-2 md:pt-28 overflow-hidden"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white" >
        <div >
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline" data-aos="fade-right">
            Skills
          </p>
        </div>
        <h1 className="text-white mx-auto font-medium text-3xl hover:underline mt-4 text-center" data-aos="fade-up"  >Frontend</h1>
        <div className="w-full grid grid-cols-2 mt-8 sm:grid-cols-3 gap-8 text-center py-8 px-6 md:px-12 sm:px-0"  >
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-lg  duration-300 py-2 rounded-lg  ${style} hover:scale-110` } data-aos="fade-up" 
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
        <h1 className="text-white mx-auto font-medium text-3xl hover:underline mt-4 text-center" data-aos="fade-up" >Backend</h1>
        <div className="w-full grid grid-cols-2 mt-2 sm:grid-cols-3 gap-8 text-center py-8 px-6 md:px-12 sm:px-0"  >
          {backend.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-lg  duration-300 py-2 rounded-lg  ${style} hover:scale-110` } data-aos="fade-up" 
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
        <h1 className="text-white mx-auto font-medium text-3xl hover:underline mt-4 text-center" data-aos="fade-up" >Others</h1>
        <div className="w-full grid grid-cols-2 mt-2 sm:grid-cols-3 gap-8 text-center py-8 px-6 md:px-12 sm:px-0"  >
          {other.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-lg  duration-300 py-2 rounded-lg  ${style} hover:scale-110` } data-aos="fade-up" 
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>

      </div>
  
      <div className="min-w-full px-4 mt-5 mb-5 md:px-32 lg:px-52  mx-auto p-3 grid grid-cols-2 md:grid-cols-4 justify-evenly overflow-x-hidden">
         <div className="w-32 m-auto flex flex-col items-center">
         <CircularProgressbar 
           className="w-32 mx-auto text-center"
           value={percentage}
                text={`${percentage}%`}
                styles={buildStyles({
                  strokeLinecap: 'butt',
                  textSize: '16px',
                  pathColor: `rgba(62, 152, 199, ${percentage / 100})`,
                  textColor: '#4682B4',
                  trailColor: '#d6d6d6',
                  background: {
                    fill: '#3e98c7',
                  },
                })}
                />
                <h1 className="text-white mt-2 font-semibold" >HTML</h1>
                </div>
         <div className="w-32 m-auto flex flex-col items-center">
         <CircularProgressbar 
           className="w-32 mx-auto text-center"
           value={70}
                text={`${70}%`}
                styles={buildStyles({
                  strokeLinecap: 'butt',
                  textSize: '16px',
                  pathColor: `rgba(210, 235, 43, ${percentage / 100})`,
                  textColor: '#D2EB2B',
                  trailColor: '#d6d6d6',
                  background: {
                    fill: '#3e98c7',
                  },
                })}
                />
                <h1 className="text-white mt-2 font-semibold" >CSS</h1>
                </div>

         <div className="w-32 m-auto flex flex-col  items-center">
         <CircularProgressbar 
           className="w-32 mx-auto text-center"
           value={80}
                text={`${80}%`}
                styles={buildStyles({
                  strokeLinecap: 'butt',
                  textSize: '16px',
                  pathColor: `rgba(217, 36, 36, ${80/ 100})`,
                  textColor: '#f88',
                  trailColor: '#d6d6d6',
                  background: {
                    fill: '#3e98c7',
                  },
                })}
                />
                <h1 className="text-white mt-2 font-semibold" >JavaScript</h1>
                </div>
         <div className="w-32 m-auto flex flex-col items-center">
         <CircularProgressbar 
           className="w-32 mx-auto text-center"
           value={75}
                text={`${75}%`}
                styles={buildStyles({
                  strokeLinecap: 'butt',
                  textSize: '16px',
                  pathColor: `rgba(43, 215, 89, ${75/ 100})`,
                  textColor: '#008000',
                  trailColor: '#d6d6d6',
                  background: {
                    fill: '#3e98c7',
                  },
                })}
                />
                <h1 className="text-white mt-2 font-semibold" >DSA</h1>
                </div>
         </div>

         <a href="https://github.com/manojattri181" target="_blank">
         <h1 className="w-fit  mx-auto text-4xl mt-18 md:mt-7 mb-6 hover:underline hover:underline-offset-4 hover:text-gray-700 hover:cursor-pointer font-bold text-white text-center">GitHub Calendar</h1>
         </a>  

        
      <div className="text-4xl font-bold min-w-full px-3 flex   justify-center mx-auto" data-aos="fade-up">
          <GitHubCalendar  style={{color:"gray"}} username="manojattri181" />
      </div>
    </div>
  );
};

export default Skills;
